// Generated from api/openapi/agents.yaml by make docs. Do not edit.
import { z } from "zod";
import { principalRefSchema } from "@pureid/auth-core";

export const automationAccountSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid().optional(),
  "name": z.string(),
  "description": z.string().optional(),
  "role": z.string(),
  "status": z.enum(["active", "inactive"]),
  "owner_admin_id": z.string().uuid().optional(),
  "owner": principalRefSchema.optional(),
  "expires_at": z.string().datetime({ offset: true }),
  "last_login_at": z.string().datetime({ offset: true }).optional(),
  "created_at": z.string().datetime({ offset: true }),
  "deactivated_at": z.string().datetime({ offset: true }).optional(),
  "token": z.string().optional(),
  "token_prefix": z.string().optional(),
  "token_id": z.string().uuid().optional(),
  "grace_expires_at": z.string().datetime({ offset: true }).optional()
}).strict();

export const automationAccountListSchema = z.object({
  "data": z.array(automationAccountSchema),
  "pagination": z.object({
    "total": z.number().int().min(0),
    "offset": z.number().int().min(0),
    "limit": z.number().int().min(1).max(200)
  }).strict()
}).strict();
